import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import ConnectionSuccess from '@/components/video-diagnostic/ConnectionSuccess.vue'
import ConnectionFailed from '@/components/video-diagnostic/ConnectionFailed.vue'
import LoadingBox from '@/components/video-diagnostic/Loading.vue'
import { Stage } from '@/types/enums/video-diagnostic.enum'
import {
  preflightTest,
  preflightTestFinished,
  preflightTestInProgress,
} from '@/composables/video-diagnostic/usePreflightTest'
import { bitrateTestInProgress } from '@/composables/video-diagnostic/useBitrateTest'
import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'

interface ConnectivityEmits {
  (e: 'nextStage', value: number): void
  (e: 'inprogress'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Connectivity',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage", "inprogress"],
  setup(__props, { emit: __emit }) {



const i18n = useI18n()

const emit = __emit

const header = computed(() => i18n.t('video-diagnostic.hang-tight'))
const message = computed(() => i18n.t('video-diagnostic.hang-tight-detail'))

const inprogress = computed(() => preflightTestInProgress.value || bitrateTestInProgress.value)
const connectionFailed = computed(
  () =>
    preflightTestFinished.value &&
    (preflightTest.error !== null ||
      !preflightTest.signalingGatewayReachable ||
      !preflightTest.turnServersReachable),
)

watch(inprogress, (value) => {
  if (value === false) {
    emit('inprogress')
  }
})

return (_ctx: any,_cache: any) => {
  return (inprogress.value)
    ? (_openBlock(), _createBlock(LoadingBox, {
        key: 0,
        stage: __props.stage,
        header: header.value,
        message: message.value
      }, null, 8, ["stage", "header", "message"]))
    : (!connectionFailed.value)
      ? (_openBlock(), _createBlock(ConnectionSuccess, {
          key: 1,
          stage: __props.stage,
          onNextStage: _cache[0] || (_cache[0] = ($event: any) => (emit('nextStage', _unref(Stage).QUALITY)))
        }, null, 8, ["stage"]))
      : (_openBlock(), _createBlock(ConnectionFailed, {
          key: 2,
          stage: __props.stage,
          onNextStage: _cache[1] || (_cache[1] = ($event: any) => (emit('nextStage', _unref(Stage).QUALITY)))
        }, null, 8, ["stage"]))
}
}

})